import { HubsSettingClient } from 'frontend-preferences-client';
import Raven from 'raven-js';
const hubsSettingClientForEmailEditor = HubsSettingClient.forCaller('EmailDragDropEditorUI');
const hubsSettingClientForTemplateEditor = HubsSettingClient.forCaller('EmailDragDropEditorUI');
export async function setHubSettingRequest({
  key,
  value
}, isTemplateEditor = false) {
  const settingsClient = isTemplateEditor ? hubsSettingClientForTemplateEditor : hubsSettingClientForEmailEditor;
  try {
    await settingsClient.write(key, String(value));
  } catch (e) {
    Raven.captureException(new Error('Error when trying to save hub setting'), {
      extra: {
        key,
        value
      }
    });
  }
}
export async function batchFetchHubSettings(keys, isTemplateEditor = false) {
  const fetchBody = keys.reduce((acc, key) => {
    acc[key] = '';
    return acc;
  }, {});
  const settingsClient = isTemplateEditor ? hubsSettingClientForTemplateEditor : hubsSettingClientForEmailEditor;
  const response = await settingsClient.batchFetch(fetchBody);
  return response;
}